<template>
  <multi-input class="component search-component" :class="{compress: compress}">
    <prefix>
      <label :for="$attrs.id" class="search-label">
        <icon class="searchable"></icon>
        <span class="sr-only">Search Input</span>
      </label>
    </prefix>
    <column>
      <input type="search" v-model.sync="localValue" v-bind="$attrs" v-on="inputListeners" v-focus="focus" :autocomplete="autocomplete">
    </column>
    <suffix>
      <button @click="reset" @keydown.enter="reset" type="button" class="btn-icon input-color search-reset">
        <span class="sr-only">clear</span>
        <icon glyph="arrow-chevron" direction="up"></icon>
      </button>
    </suffix>
  </multi-input>
</template>

<script lang="ts">
  import Vue from "vue";
  import localValueEmissionMixin from "../mixins/localValueEmissionMixin";

  export default Vue.extend({
    inheritAttrs: false,
    mixins: [localValueEmissionMixin],

    props: {
      compress: {
        type: Boolean,
        default: false
      },
      value: {
        type: String,
        default: ""
      },
      focus: {
        type: Boolean,
        default: false,
      },
      autocomplete: {
        type: String,
        default: "on"
      }
    },
    data: function () {
      // extract out input listener so that v-model works as intended
      const {input, ...others} = this.$listeners;
      return {
        inputListeners: others, // bind all other listeners to <input>
      };
    },
    methods: {
      reset(e){
        this.$emit('reset', e);
      }
    }
  });
</script>
